export default __webpack_public_path__ + "static/excel-d2f4be85c24ff3f18a74acf669fc1e72.svg";